////////LIBRARY/////////
import ActionsTypes from '../../constants/ActionsTypes'

const modals = {
	hydrateModal: (data) => ({
		type: ActionsTypes.HYDRATE_MODAL,
		payload: {
			data,
		},
	}),
	closeModal: () => ({
		type: ActionsTypes.CLOSE_MODAL,
		payload: {},
	}),
	closeModalRedirect: () => ({
		type: ActionsTypes.CLOSE_MODAL_REDIRECT,
		payload: {},
	}),

	/**
	 * Open and hydrate modal content
	 * @param {string} content
	 * @param {boolean} insideModal
	 * @return {{payload: {title: *, content: *}, type: string}}
	 */
	tooltipHelpOpen: (content, icon, insideModal = false) => ({
		type: ActionsTypes.OPEN_TOOLTIP_HELP,
		payload: { content, icon, insideModal },
	}),
	/**
	 * Close and reset data
	 * @return {{payload: {}, type: string}}
	 */
	tooltipHelpClose: () => ({
		type: ActionsTypes.CLOSE_TOOLTIP_HELP,
		payload: {},
	}),
}

export default modals
